module.exports = __webpack_public_path__ + "img/ico-android.8d83f86.svg";